import type { FullRecord } from "@shared/types";
import { SL, SC } from "../constants";
import { dSt, fmtS } from "../util";
import { applyFilter, type FilterState } from "./FilterToolbar";

interface Props {
  records: FullRecord[];
  filter: FilterState;
  onOpen: (id: number) => void;
}

export function RecordTable({ records, filter, onOpen }: Props) {
  const filtered = applyFilter(records, filter);

  return (
    <div className="table-wrap">
      <table>
        <thead>
          <tr>
            <th className="c-dt">Data</th>
            <th className="c-resp">Resp.</th>
            <th className="c-cli">Cliente</th>
            <th className="c-ramo">Ramo</th>
            <th className="c-prox">Próximo contato</th>
            <th className="c-st">Status</th>
            <th className="c-obs">Última observação</th>
            <th className="c-act"></th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((d) => <Row key={d.id} d={d} onOpen={onOpen} />)}
        </tbody>
      </table>
      {filtered.length === 0 && <div className="empty">Nenhum registro encontrado.</div>}
    </div>
  );
}

function Row({ d, onOpen }: { d: FullRecord; onOpen: (id: number) => void }) {
  const ds = d.prox_data ? dSt(d.prox_data) : "";
  const isOverdue = (ds === "late" || ds === "today") && d.status !== "efetivado" && d.status !== "perdido";
  const histCount = d.historico?.length || 0;
  const docCount = d.docs?.length || 0;
  const mp = d.status === "perdido" && d.motivo_perda ? d.motivo_perda : null;

  return (
    <tr className={isOverdue ? "ov" : undefined}>
      <td style={{ color: "var(--tx2)", fontSize: 12 }}>{d.data || "—"}</td>
      <td style={{ fontSize: 12, color: "var(--tx2)" }}>{d.resp || "—"}</td>
      <td style={{ fontWeight: 500 }}>
        {d.cliente}
        {histCount > 0 && <span className="hb">{histCount}</span>}
        {docCount > 0 && <span className="db">{docCount} doc{docCount > 1 ? "s" : ""}</span>}
      </td>
      <td><span className="badge b-ra">{d.ramo || "—"}</span></td>
      <td>
        {d.prox_data ? (
          <span className={"pd" + (ds === "late" ? " late" : ds === "today" ? " today" : "")}>
            {fmtS(d.prox_data)}{d.prox_mot ? " · " + d.prox_mot.substring(0, 15) : ""}
          </span>
        ) : (
          <span style={{ color: "var(--tx3)", fontSize: 12 }}>—</span>
        )}
      </td>
      <td>
        <span className={"badge " + (SC[d.status] || "b-ra")}>{SL[d.status] || d.status}</span>
        {mp && (
          <span className="badge b-pe" style={{ fontSize: 10, padding: "2px 6px", marginLeft: 4, verticalAlign: "middle" }} title={mp + (d.motivo_det ? " — " + d.motivo_det : "")}>
            {mp.substring(0, 20)}{mp.length > 20 ? "…" : ""}
          </span>
        )}
      </td>
      <td style={{ fontSize: 12, color: "var(--tx2)" }} title={d.obs || undefined}>{d.obs || "—"}</td>
      <td>
        <button className="btn-ico" onClick={() => onOpen(d.id)}>
          <svg viewBox="0 0 24 24" style={{ width: 14, height: 14, stroke: "currentColor", fill: "none", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }}>
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
          </svg>
        </button>
      </td>
    </tr>
  );
}
